/**
 * Nombres de rol equivalentes a "líder de sucursal" (el string exacto en BD puede variar).
 * No incluir "Líder de líderes": es otro perfil.
 */
const BRANCH_LEADER_ROLE_NAMES = [
  "Lider de sucursal",
  "Líder de Sucursal SUC",
  "Líder de Sucursal",
] as const;

export function isBranchLeaderRole(role: string | undefined | null): boolean {
  if (!role) return false;
  return (BRANCH_LEADER_ROLE_NAMES as readonly string[]).includes(role);
}

/** true si la ruta está pensada para algún líder de sucursal (por cualquiera de los alias). */
export function routeAllowsBranchLeader(validRoles: string[] | undefined): boolean {
  if (!validRoles?.length) return false;
  return validRoles.some((r) => isBranchLeaderRole(r));
}

/**
 * Coincidencia de rol con validRoles del menú: igualdad exacta o mismo perfil "líder de sucursal"
 * con distinto nombre en BD.
 */
export function roleMatchesValidRoles(
  userRole: string,
  validRoles: string[],
): boolean {
  if (validRoles.includes(userRole)) return true;
  if (isBranchLeaderRole(userRole) && routeAllowsBranchLeader(validRoles)) {
    return true;
  }
  return false;
}
